import Presenter from 'microcosm/addons/presenter'
import {
  filterRegion,
  focusChartShape,
  blurChartShape,
  toggleFixed
} from '../actions/ui'
import RA from 'ra-config'

const { regionOptionList } = RA.app.page

class Dashboard extends Presenter {
  setup(repo, { location }) {
    const { region } = location.query

    if (region) {
      const currentRegion = regionOptionList.find(r => r.value === region)
      currentRegion && repo.push(filterRegion, currentRegion)
    } else {
      repo.push(filterRegion, regionOptionList[0])
    }
  }

  patch(query) {
    const { router, location } = this.props

    router.push({
      pathname: location.pathname,
      query: { ...location.query, ...query }
    })
  }

  visit(repo, pathname, query) {
    this.props.router.push({ pathname, query })
  }

  intercept() {
    return {
      visit: this.visit,
      filterRegion: (repo, region) => {
        repo.push(filterRegion, region)
        this.patch({ region: region.value })
      },
      patchQuery: (repo, params) => {
        this.patch(params)
        if (!params.selected) {
          repo.push(blurChartShape)
        }
      },
      focusChartShape: (repo, id) => {
        repo.push(focusChartShape, id)
      },
      blurChartShape: repo => {
        repo.push(blurChartShape)
      },
      toggleFixed: (repo, shouldFix) => {
        repo.push(toggleFixed, shouldFix)
      }
    }
  }
}

export default Dashboard



// WEBPACK FOOTER //
// ./src/presenters/dashboard.js